import { i18nMark } from 'lingui-react';

const formattedMessages = {
  loading: i18nMark('Loading...'),
};

export default formattedMessages;



// WEBPACK FOOTER //
// ./utils/mapping/messages.js